import React from "react";

import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { ProfessionsTranslations } from "@/models/ProfessionModel.ts";
import { PractitionerUser, userFormattedName } from "@/models/UserModel.ts";
import { Queries } from "@/queries/Queries.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Card } from "@/uiKit/atoms/Card.tsx";
import { CardContent } from "@/uiKit/atoms/CardContent.tsx";
import { CardHeader } from "@/uiKit/atoms/CardHeader.tsx";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

export const GeneralInformation: React.FC = () => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  return (
    <Card id="general-info-card" className={styles.container}>
      <CardHeader id="general-info-title" title={t("pages.account.generalInformation.title")} />
      <CardContent>
        <GeneralInformationContent />
      </CardContent>
    </Card>
  );
};

export const GeneralInformationContent: React.FC = () => {
  const me = Queries.user.usePractitionerMe({});

  return <PractitionerInformation practitioner={me} />;
};

type InformationProps = {
  practitioner: PractitionerUser;
};

const PractitionerInformation: React.FC<InformationProps> = ({ practitioner }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  return (
    <div className={styles.infoDisplay}>
      <div className={styles.infoDisplayContent}>
        <Typography variant="bodyLarge">{userFormattedName(practitioner.lastName, practitioner.firstName)}</Typography>
        <Typography variant="bodySmall">{practitioner.email}</Typography>
        <Typography variant="bodySmall">{t(ProfessionsTranslations[practitioner.qualification])}</Typography>
      </div>
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css``,
  infoDisplay: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: ${theme.spacing(12)};
  `,
  infoDisplayContent: css`
    display: flex;
    flex-direction: column;
  `,
});
